import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://michelson-law.com';

const PageMeta = ({ title, description, path }) => {
  const canonical = path ? `${SITE_URL}${path}` : `${SITE_URL}/`;

  return (
    <Helmet prioritizeSeoTags>
      <html lang="he" dir="rtl" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="he_IL" />
      <meta property="og:url" content={canonical} />
      <link rel="canonical" href={canonical} />
    </Helmet>
  );
};

export default PageMeta;
